import { HttpParams } from '@angular/common/http';
import { Filter } from '../../../../models';
import { periodicidadeAnual, PeriodicidadeFilter } from '../../../../shared';
import { Pessoa } from '../../../pessoa/pessoa';
import { representanteAtivo } from '../../../pessoa/representante/situacao';

/** Propriedades do filtro dos KPIs de Produtividade */
export interface ProdutividadeFilterProps {
    // Periodicidade
    periodicidade: PeriodicidadeFilter;

    // Cross Sell
    crossSells: number[];
    // Cliente
    idPessoa: number;
    pessoa: Pessoa;
    // Representantes
    idsRepresentantes: number[];
    somenteRepresentantesAtivos: boolean;
    modalidadesComerciaisRepresentantes: number[];
    // Atendentes
    idsAtendentes: number[];
    // Gerentes
    idsGerentes: number[];

    // Classificações de Clientes
    idsClassificacoesClientes: number[];
    classificacaoClienteNull: boolean;

    // Classificações de Itens
    idsClassificacoesItens: number[];
    classificacaoItemNull: boolean;

    // Pedidos
    pedidosStatuses: number[];
}

/** Filtro dos KPIs de Produtividade */
export class ProdutividadeFilter implements Filter, ProdutividadeFilterProps {
    isFilterDirty = false;

    // Periodicidade
    periodicidade: PeriodicidadeFilter;

    // Cross Sell
    crossSells: number[] = [];
    // Cliente
    idPessoa: number;
    pessoa: Pessoa;
    // Representantes
    idsRepresentantes: number[] = [];
    somenteRepresentantesAtivos = true;
    modalidadesComerciaisRepresentantes: number[] = [];
    // Atendentes
    idsAtendentes: number[] = [];
    // Gerentes
    idsGerentes: number[] = [];

    // Classificações de Clientes
    idsClassificacoesClientes: number[] = [];
    classificacaoClienteNull = false;

    // Classificações de Itens
    idsClassificacoesItens: number[] = [];
    classificacaoItemNull = false;

    // Pedidos
    pedidosStatuses: number[] = [];

    constructor(props: Partial<ProdutividadeFilterProps>) {
        if (props) {
            this.periodicidade = new PeriodicidadeFilter(props.periodicidade);
            this.crossSells = props.crossSells ?? [];
            this.idPessoa = props.idPessoa;
            this.pessoa = props.pessoa;
            this.idsRepresentantes = props.idsRepresentantes ?? [];
            this.somenteRepresentantesAtivos = props.somenteRepresentantesAtivos ?? true;
            this.modalidadesComerciaisRepresentantes = props.modalidadesComerciaisRepresentantes ?? [];
            this.idsAtendentes = props.idsAtendentes ?? [];
            this.idsGerentes = props.idsGerentes ?? [];
            this.idsClassificacoesClientes = props.idsClassificacoesClientes ?? [];
            this.classificacaoClienteNull = props.classificacaoClienteNull ?? false;
            this.idsClassificacoesItens = props.idsClassificacoesItens ?? [];
            this.classificacaoItemNull = props.classificacaoItemNull ?? false;
            this.pedidosStatuses = props.pedidosStatuses ?? [];
        } else {
            this.periodicidade = new PeriodicidadeFilter({
                periodicidade: periodicidadeAnual.id,
                data: new Date()
            });
        }
    }

    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Periodicidade
        params = this.periodicidade.createParams(params);

        // Cross Sells
        this.crossSells?.forEach(crossSell => params = params.append('crossSell', crossSell.toString()));

        // Representantes
        this.idsRepresentantes?.forEach(idRepresentante => {
            params = params.append('idRepresentante', idRepresentante.toString());
        });
        // Situações Representantes
        if (this.somenteRepresentantesAtivos) {
            params = params.append('situacaoRepresentante', representanteAtivo.id.toString());
        }
        // Modalidades Comerciais Representantes
        this.modalidadesComerciaisRepresentantes?.forEach(modalidadeComercialRepresentante => params = params.append('modalidadeComercialRepresentante', modalidadeComercialRepresentante.toString()));

        // Atendentes
        this.idsAtendentes?.forEach(idAtendente => {
            params = params.append('idsAtendentes', idAtendente.toString());
        });

        // Gerentes
        this.idsGerentes?.forEach(idGerente => {
            params = params.append('idsGerentes', idGerente.toString());
        });

        // Pessoa
        if (this.idPessoa) {
            params = params.append('idPessoa', this.idPessoa.toString());
        }

        // Classificações de clientes
        this.idsClassificacoesClientes?.forEach(idClassificacaoCliente => {
            if (idClassificacaoCliente > 0) {
                params = params.append('idClassificacaoCliente', idClassificacaoCliente.toString());
            }
        });
        // Sem classificação de cliente
        if (this.classificacaoClienteNull) {
            params = params.append('classificacaoClienteNull', 'true');
        }

        // Classificações de itens
        this.idsClassificacoesItens?.forEach(idClassificacaoItem => {
            if (idClassificacaoItem > 0) {
                params = params.append('idClassificacaoItem', idClassificacaoItem.toString());
            }
        });
        // Sem classificação de item
        if (this.classificacaoItemNull) {
            params = params.append('classificacaoItemNull', 'true');
        }

        // Status dos Pedidos
        this.pedidosStatuses?.forEach(pedidoStatus => {
            params = params.append('pedidoStatus', pedidoStatus.toString())
        });

        return params;
    }

    clear() {
        this.isFilterDirty = false;

        this.idsRepresentantes = [];
        this.somenteRepresentantesAtivos = true;
        this.modalidadesComerciaisRepresentantes = [];
        this.idsAtendentes = [];
        this.idsGerentes = [];
        this.idPessoa = null;
        this.pessoa = null;
        this.pedidosStatuses = [];
        this.crossSells = [];
        this.idsClassificacoesClientes = [];
        this.classificacaoClienteNull = false;
        this.idsClassificacoesItens = [];
        this.classificacaoItemNull = false;
    }


    /**
     * Cria o objeto através do JSON informado
     *
     * @param json JSON com as propriedades para criar o objeto
     * @returns objet criado
     */
    static fromJSON(json: string): ProdutividadeFilter {
        return new ProdutividadeFilter(JSON.parse(json));
    }
}
